import { useEffect, useRef, useState } from 'react';
import { BasketContentHeader } from './BasketContentHeader';
import { BasketContentCart } from './BasketContentCart';
import { BasketContentFavorite } from './BasketContentFavorite';
import { ShoppingCartService } from './services/shopping-cart.service';
import { BasketEditFabricItem } from './editItems/BasketEditFabricItem';
import { BasketEditCurtainsItem } from './editItems/BasketEditCurtainsItem';
import { BasketEditBedspreadsItem } from './editItems/BasketEditBedspreadsItem';
import { BasketEditBeanbagsItem } from './editItems/BasketEditBeanbagsItem';
import { BasketEditDuvetsItem } from './editItems/BasketEditDuvuetsItem';
import { BasketEditCushionsItem } from './editItems/BasketEditCushionsItem';
import { BasketEditPelmetItem } from './editItems/BasketEditPelmetItem';
import { BasketEditTableclothsItem } from './editItems/BasketEditTableclothsItem';
import { BasketEditRomanBlindsItem } from './editItems/BasketEditRomanBlindsItem';
import { BasketEditValancesItem } from './editItems/BasketEditValancesItem';
import { BasketEditRollerBlindsItem } from './editItems/BasketEditRollerBlindsItem';
import { useErrorBoundary } from '../ErrorBoundary';

export function BasketBody(props) {
    const defalultEditItem = { productId: null };
    const { shoppingBag, favorites, toggleBascket, actions, scrollToBottom } = props;
    const handleError = useErrorBoundary();

    const [editItem, setEditItem] = useState(defalultEditItem);
    const [activeTab, setActiveTab] = useState(0);
    const [lastSaved, setLastSaved] = useState(favorites.count > 0 ? favorites.items[0] : undefined);

    const overlayRef = useRef(null);
    const boxRef = useRef(null);
    const isFirstRender = useRef(true);

    // scroll to bottom on open
    useEffect(() => {
        if (!scrollToBottom) return;
        const id = requestAnimationFrame(() => {
            if (boxRef.current) {
                boxRef.current.scrollTop = boxRef.current.scrollHeight;
            }
        });
        return () => cancelAnimationFrame(id);
    }, [scrollToBottom, shoppingBag]);

    // reset scroll when edit item
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (boxRef.current) {
            boxRef.current.scrollTop = 0;
        }
    }, [editItem]);

    useEffect(() => {
        setLastSaved(favorites.count > 0 ? favorites.items[0] : undefined);
    }, [favorites.items])

    const changeCartType = (index) => {
        setActiveTab(index);
    }

    const editFabricItem = async (item) => {
        if (item.productType !== 11 && item.productType !== 12) {
            try {
                const editItem = await ShoppingCartService.get('details/' + item.productId + "/" + item.productType)
                    .catch(error => { handleError('Could not get item details. Please contact administrator'); });
                setEditItem(editItem);
            } catch (error) {
                console.error('Error fetching edit item:', error);
            }
        } else {
            setEditItem(item);
        }

        if (window.updateCart) {
            updateCart()
        }
    }

    const updateFabricItem = async (item) => {
        if (item) {
            await actions.onEdit(item);
        }
        setEditItem(defalultEditItem);

        if (window.updateCart) {
            updateCart()
        }
    }

    const handleClose = (e) => {
        setEditItem(defalultEditItem)

        if (window.updateCart) {
            updateCart()
        }
    }

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                overlayRef.current &&
                boxRef.current &&
                overlayRef.current.contains(event.target) &&
                !boxRef.current.contains(event.target)
            ) {
                toggleBascket();
            }
        }

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [toggleBascket]);

    return (
        <div ref={overlayRef} className="overlay-with-box headings-overlay active-group mobile-menu d-flex">
            <div ref={boxRef} className="overlay-box active-group flex-column fit-content mobile-menu-container sm-px-12 sm-pb-40">

                {!editItem || !editItem.productId ? (
                    <div className="width-550 sm-max-w-100" id="basket-main-content">
                        <BasketContentHeader activeTab={activeTab} cartItemsCount={shoppingBag.count} favoriteItemsCount={favorites.count} changeCartType={changeCartType} toggleBascket={props.toggleBascket} />
                        <div className="col" id="basket-content">
                            {activeTab === 0 && 
                                <BasketContentCart 
                                    shoppingBag={shoppingBag} 
                                    showContinueButton={scrollToBottom} 
                                    toggleBascket={props.toggleBascket} 
                                    actions={({ ...actions, editFabricItem })}
                                    lastSavedItem={lastSaved}
                                />}
                            
                            {activeTab === 1 && 
                                <BasketContentFavorite 
                                    items={favorites.items}
                                    actions={({ ...actions, editFabricItem })}
                                />}
                        </div>
                    </div>
                ) : (

                    <>
                        {editItem.productId && editItem.productType == 1 &&
                            <div className="active-group">
                                <div className="width-610 item-edit sm-max-w-100">
                                    <BasketEditCurtainsItem item={editItem} updateFabricItem={updateFabricItem} close={handleClose} />
                                </div>
                            </div>
                        }

                        {editItem.productId && editItem.productType == 2 &&
                            <div className="active-group">
                                <div className="width-610 item-edit sm-max-w-100">
                                    <BasketEditRomanBlindsItem item={editItem} updateFabricItem={updateFabricItem} close={handleClose} />
                                </div>
                            </div>
                        }

                        {editItem.productId && editItem.productType == 3 &&
                            <div className="active-group">
                                <div className="width-610 item-edit sm-max-w-100">
                                    <BasketEditBeanbagsItem item={editItem} updateFabricItem={updateFabricItem} close={handleClose} />
                                </div>
                            </div>
                        }

                        {editItem.productId && editItem.productType == 4 &&
                            <div className="active-group">
                                <div className="width-610 item-edit sm-max-w-100">
                                    <BasketEditBedspreadsItem item={editItem} updateFabricItem={updateFabricItem} close={handleClose} />
                                </div>
                            </div>
                        }

                        {editItem.productId && editItem.productType == 5 &&
                            <div className="active-group">
                                <div className="width-610 item-edit sm-max-w-100">
                                    <BasketEditCushionsItem item={editItem} updateFabricItem={updateFabricItem} close={handleClose} />
                                </div>
                            </div>
                        }

                        {editItem.productId && editItem.productType == 6 &&
                            <div className="active-group">
                                <div className="width-610 item-edit sm-max-w-100">
                                    <BasketEditPelmetItem item={editItem} updateFabricItem={updateFabricItem} close={handleClose} />
                                </div>
                            </div>
                        }

                        {editItem.productId && editItem.productType == 7 &&
                            <div className="active-group">
                                <div className="width-610 item-edit sm-max-w-100">
                                    <BasketEditRollerBlindsItem item={editItem} updateFabricItem={updateFabricItem} close={handleClose} />
                                </div>
                            </div>
                        }

                        {editItem.productId && editItem.productType == 8 &&
                            <div className="active-group">
                                <div className="width-610 item-edit sm-max-w-100">
                                    <BasketEditValancesItem item={editItem} updateFabricItem={updateFabricItem} close={handleClose} />
                                </div>
                            </div>
                        }

                        {editItem.productId && editItem.productType == 9 &&
                            <div className="active-group">
                                <div className="width-610 item-edit sm-max-w-100">
                                    <BasketEditTableclothsItem item={editItem} updateFabricItem={updateFabricItem} close={handleClose} />
                                </div>
                            </div>
                        }

                        {editItem.productId && editItem.productType == 10 &&
                            <div className="active-group">
                                <div className="width-610 item-edit sm-max-w-100">
                                    <BasketEditDuvetsItem item={editItem} updateFabricItem={updateFabricItem} close={handleClose} />
                                </div>
                            </div>
                        }

                        {editItem.productId && (editItem.productType == 11 || editItem.productType == 12) &&
                            <div className="active-group">
                                <div className="width-610 item-edit sm-max-w-100">
                                    <BasketEditFabricItem item={editItem} updateFabricItem={updateFabricItem} close={handleClose} />
                                </div>
                            </div>
                        }
                    </>
                )
                }
            </div>
        </div>
    );
}